import { LogoIcon } from "@datagame/ui";
import classNames from "classnames/bind";

import styles from "./ImageCover.module.scss";

const cx = classNames.bind(styles);

export interface ImageCoverProps {
  imageClassName?: string;
}

export const ImageCover = ({ imageClassName }: ImageCoverProps) => {
  const imageClassNames = cx("imageArea", imageClassName);

  return (
    <div className={imageClassNames}>
      <LogoIcon className={styles.logo} />
    </div>
  );
};
